
import { defineComponent, onMounted, ref } from 'vue'
import { axios, ApiResponse } from '@/plugins/axios'
import { VideoBookmarkAttributes } from '@/types/models/video-bookmark'
import LayoutsAuth from '@/layouts/Auth.vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'
import { toArray } from '@/utils/array'
import BasePagination from '@/components/BasePagination.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, VideoThumbnail, BasePagination, LayoutsAuthWidth },
  setup() {
    const bookmarks = ref<VideoBookmarkAttributes[]>([])
    const pageSize = ref(16)
    const pagedList = ref([])

    onMounted(() => {
      axios.get<ApiResponse<VideoBookmarkAttributes[]>>('/video/bookmark')
        .then(response => {
          bookmarks.value = response.data.payload
        })
    })

    return {
      bookmarks,
      toArray,
      pageSize,
      pagedList
    }
  },
})
